import { SlideFromLeft, SlideFromRight } from "../../ui/animations";
import TeamFinder from "@/components/elements/TeamFinder";
import { Section } from "@/components/ui/section";
import { ScrollContainer } from "@/components/ui/scroll-container";
import { useLocation } from "react-router-dom";

import { Link } from "react-router-dom";
import Hero from "./Hero";
import { useEffect } from "react";

export default function AboutUs() {
const location = useLocation();
 useEffect(() => {
  if (location.hash) {
    const el = document.getElementById(location.hash.replace("#", ""));
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      return;
    }
  }

  window.scrollTo(0, 0);
}, [location]);

    return (
        
        <ScrollContainer 
        key={location.pathname}
        snapType="y" 
        snapBehavior="mandatory" 
        className="">
            {/* Hero Section */}            
           <Section
               scrollSnap={true}
               fullHeight={true}
               variant="dark"
               contentPosition="top"
               contained={false}
               padding="none"
           >
               <Hero />
           </Section>
             <Section
                           scrollSnap={true}
                           variant="dark"
                           contentPosition="center"
                           padding="xl"
                           className=""
                       >
                           <div className="flex lg:flex-row flex-col justify-center items-center">
                               <SlideFromLeft Component={
                                   <div className="w-full max-w-xs">
                                       <h1 className="font-semibold text-center text-xl text-white lg:mb-0 mb-4">
                                           Our Commercial Overview
                                       </h1>
                                   </div>
                               } />
                               <div className="h-24 w-1 border-r border-gray-400 mx-8 lg:block hidden" />
                               <SlideFromRight Component={
                                   <div className="w-full lg:pl-8 lg:max-w-xl xl:max-w-full">                                       
                                       <p className="text-white font-thin text-justify md:text-center lg:text-left lg:px-0 px-4 ">
                                           Harvey Norman Commercial NZ is the B2B division of Harvey Norman, providing residential and commercial solutions across appliances, bespoke furniture, bedding, and décor.
                                           With years of experience serving businesses of all sizes, we deliver reliable solutions, exceptional service, and industry expertise.
                                       </p>
                                   </div>
                               } />
                           </div>
                       </Section>


            {/* Benefits of Working with Us */}
            <Section
                scrollSnap={true}
                variant="light"
                contentPosition="top"
                padding="xl"
                overlayColor="transparent"
            >
                {/* Header Section */}
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 leading-tight">
                        Why Choose
                        <span className="text-gradient-red"> Harvey Norman</span>
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                        We thrive on making procurement easy with comprehensive solutions, exceptional service, and unmatched expertise.
                    </p>
                </div>

                {/* Benefits Cards Grid */}
                <SlideFromLeft Component={
                    <div className="grid lg:grid-cols-2 xl:grid-cols-2 gap-8 mb-16">
                        {/* Comprehensive Solutions Card */}
                        <div className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">                            
                            <div className="absolute inset-0 bg-gradient-to-br from-gray-200/40 to-gray-300/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            <div className="relative z-10">
                                <div className="flex items-center mb-6">                                    
                                    <div className="w-16 h-16 flex-shrink-0 flex-grow-0 bg-gradient-to-br from-harvey-red to-red-600 rounded-2xl flex items-center justify-center shadow-lg mr-4 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                        </svg>
                                    </div>                                    
                                    <h3 className="text-2xl font-bold text-gray-800 group-hover:text-harvey-red transition-colors duration-300">
                                        Comprehensive Solutions
                                    </h3>
                                </div>
                                <div className="space-y-4">
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Extensive Product Range:</span> Access thousands of appliances, furniture, bedding, and technology solutions.
                                        </p>
                                    </div>
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Expert Advice:</span> Our specialists provide tailored recommendations based on your project's unique needs.
                                        </p>
                                    </div>
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Scalable Solutions:</span> We work with businesses of all sizes, from startups to enterprise-level projects.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Exceptional Service Card */}
                        <div className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">                            
                            <div className="absolute inset-0 bg-gradient-to-br from-gray-200/40 to-gray-300/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            <div className="relative z-10">
                                <div className="flex items-center mb-6">                                    
                                    <div className="w-16 h-16 flex-shrink-0 flex-grow-0 bg-gradient-to-br from-harvey-red to-red-600  rounded-2xl flex items-center justify-center shadow-lg mr-4 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>                                    
                                    <h3 className="text-2xl font-bold text-gray-800 group-hover:text-harvey-red transition-colors duration-300">
                                        Exceptional Service & Support
                                    </h3>
                                </div>
                                <div className="space-y-4">
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Dedicated Account Managers:</span> Personalised service from experienced professionals who understand your business.
                                        </p>
                                    </div>
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Reliable Delivery & Installation:</span> Professional installation services ensuring products arrive on time and ready to use.
                                        </p>
                                    </div>
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Comprehensive After-Sales:</span> Ongoing support, warranties, and maintenance services long after purchase.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Strong Partnerships Card */}
                        <div className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">                            
                            <div className="absolute inset-0 bg-gradient-to-br from-gray-200/40 to-gray-300/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            <div className="relative z-10">
                                <div className="flex items-center mb-6">                                    
                                    <div className="w-16 h-16 flex-shrink-0 flex-grow-0 bg-gradient-to-br from-harvey-red to-red-600 rounded-2xl flex items-center justify-center shadow-lg mr-4 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 7H16.5c-.8 0-1.54.37-2.01 1l-2.49 3.32V7h-2v14h2v-5l1.5-2 2.5 5h2zM12.5 11.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5zM5.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm2 16v-7H9v-2c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v2h1.5v7H5.5z" />
                                        </svg>
                                    </div>                                    
                                    <h3 className="text-2xl font-bold text-gray-800 group-hover:text-harvey-red transition-colors duration-300">
                                        Strong Partnerships & Reputation
                                    </h3>
                                </div>
                                <div className="space-y-4">
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Trusted Industry Partner:</span> Decades of successful partnerships with businesses across all industries and scales.
                                        </p>
                                    </div>
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Market Reputation:</span> Recognised industry leader for reliability, quality, and exceptional commercial service.
                                        </p>
                                    </div>
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Cost-Effective Solutions:</span> Competitive trade pricing, volume discounts, and exclusive commercial offers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Commercial Showroom Experience Card */}
                        <div className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">                            
                            <div className="absolute inset-0 bg-gradient-to-br from-gray-200/40 to-gray-300/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            <div className="relative z-10">
                                <div className="flex items-center mb-6">                                    
                                    <div className="w-16 h-16 flex-shrink-0 flex-grow-0 bg-gradient-to-br from-harvey-red to-red-600 rounded-2xl flex items-center justify-center shadow-lg mr-4 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2l.09.01h-.18L12 2zm0 .01C6.48 2.01 2 6.5 2 12s4.48 9.99 10 9.99 10-4.48 10-9.99S17.52 2.01 12 2.01zM8.5 7.5A1.5 1.5 0 0 1 10 6h4a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 14 10h-4a1.5 1.5 0 0 1-1.5-1.5v-1zM6 12a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-5z" />
                                        </svg>
                                    </div>                                    
                                    <h3 className="text-2xl font-bold text-gray-800 group-hover:text-harvey-red transition-colors duration-300">
                                        Commercial Showroom Experience
                                    </h3>
                                </div>
                                <div className="space-y-4">
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Personalised Consultations:</span> Private appointments with specialists to discuss your unique project requirements.
                                        </p>
                                    </div>
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Curated Selection:</span> Explore premium products, handpicked and displayed for commercial applications.
                                        </p>
                                    </div>
                                    <div className="flex items-start">                                        
                                        <div className="w-2 h-2 bg-harvey-red rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            <span className="font-semibold text-gray-800">Nationwide Network:</span> Multiple commercial showrooms across New Zealand for hands-on product experiences.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                } />



                <div className="text-center">
                    <div className="bg-white rounded-3xl px-8 py-12 lg:p-12 shadow-xl border border-gray-100">
                        <h3 className="text-2xl lg:text-3xl font-bold text-gray-800 mb-6">
                            Ready to Start Your Next Project?
                        </h3>
                        <p className="text-lg lg:text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
                            Join thousands of satisfied commercial clients who trust Harvey Norman with their business needs
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">                            
                            <Link
                                to="/contact-us"
                                className="btn group relative w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-harvey-red to-red-600 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 uppercase tracking-wide"
                            >
                                <span className="relative z-10">Start Your Project Today</span>
                                <div className="absolute inset-0 bg-gradient-to-r from-red-600 to-red-700 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </Link>

                            <Link
                                to="/showroom"
                                className="btn group w-full sm:w-auto px-8 py-4 bg-white text-harvey-red font-semibold rounded-2xl border-2 border-harvey-red hover:bg-harvey-red hover:text-white transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1 uppercase tracking-wide"
                            >
                                Visit Our Showrooms
                            </Link>
                        </div>
                    </div>
                </div>
            </Section>
            {/* Team Members. moved id="team-finder to TeamFinder component */}
            <Section             
            scrollSnap={true} 
            variant="light" 
            padding="none" 
            contained={false}>
                <TeamFinder />
            </Section>
            
        </ScrollContainer>
        
       
        
    );
};


